var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.375rem",
    height: "1.375rem",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 20.9998C16.5227 20.9998 20.9999 16.5226 20.9999 10.9998C20.9999 5.47691 16.5227 0.999756 10.9999 0.999756C5.47703 0.999756 0.999878 5.47691 0.999878 10.9998C0.999878 16.5226 5.47703 20.9998 10.9999 20.9998Z",
    fill: "#A3BAC6",
    fillOpacity: 0.2,
    stroke: "#5796B9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 5.99951V11.9995V5.99951ZM10.9999 15.4995V15.9995V15.4995Z",
    fill: "#A3BAC6",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 15.4995V15.9995M10.9999 5.99951V11.9995V5.99951Z",
    stroke: "#5796B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.3aef5de7cb9b2c72b65b6aa75a080156.svg";
export { ForwardRef as ReactComponent };